

import { Link } from "@tanstack/react-router";
import { Card, CardContent } from "@workspace/web-ui/components/card";

import paymentSuccess from "~/assets/images/payment-success.svg";
import { useSearch } from "@tanstack/react-router";
import { useSuspenseQuery } from "@tanstack/react-query";
import { getMedicationRefillQueryOptions, getPrescriptionMedicationQueryOptions } from "../api/queries";

export function MedicationPaymentSuccess() {
  const { prescription_id } = useSearch({ from: "/(dashboard)/dashboard/weight-loss/medicals/confirmation" })

  const { data: medicationPrescriptionData } = useSuspenseQuery(getPrescriptionMedicationQueryOptions(prescription_id ?? ""))

  const medicationResponse = medicationPrescriptionData?.prescription.medications

  if (!medicationResponse) {
    return null
  }

  const total = medicationResponse?.reduce((sum, item) => sum + item.cost, 0) || 0;

  return (
    <div className="flex items-center justify-center bg-muted/50 px-4">
      <Card className=" w-auto rounded-xl shadow-xl">
        <CardContent className="p-6">
          <div className="flex flex-col items-center text-center">
            <div className="size-20 mb-3">
              <img src={paymentSuccess} alt="payment-image" className="w-full" />
            </div>
            <h2 className="text-[40px] font-semibold">Payment Successful</h2>
            <p className="text-sm flex text-center md:w-[60%] w-[90%] text-muted-foreground mt-1">
              Your payment has been confirmed. You will receive your medications shortly.
            </p>

            <div className="w-full mt-6 text-sm text-left space-y-4">
              {
                medicationResponse?.map((medication, i) => (
                  <div className="flex justify-between" key={i}>
                    <span className="#2D2F35">{medication.name}</span>
                    <span className="text-[#202020CC]">
                      $ {medication.cost}
                    </span>
                  </div>
                ))
              }

              <div className="flex justify-between">
                <span className="#2D2F35">Payment Method</span>
                <span className="text-[#202020CC]">
                  Stripe
                </span>
              </div>

              <div className="flex justify-between">
                <span className="#2D2F35">Total</span>
                <span className="text-[#202020CC]">
                  ${total}
                </span>
              </div>
            </div>

            <Link to="/dashboard/weight-loss/medicals" className={"mt-6 w-full text-white h-11 flex justify-center items-center rounded-lg bg-[#4272DD]"}>Return to dashboard</Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export function RefillPaymentSuccess() {
  const { refill_id } = useSearch({ from: "/(dashboard)/dashboard/weight-loss/medicals/refill-confirmation" })

  const { data: medicationRefillData } = useSuspenseQuery(getMedicationRefillQueryOptions(refill_id ?? ""))

  const refillMedicationResponse = medicationRefillData?.refill_request

  if (!refillMedicationResponse) {
    return null
  }

  return (
    <div className="flex items-center justify-center bg-muted/50 px-4">
      <Card className=" w-auto rounded-xl shadow-xl">
        <CardContent className="p-6">
          <div className="flex flex-col items-center text-center">
            <div className="size-20 mb-3">
              <img src={paymentSuccess} alt="payment-image" className="w-full" />
            </div>
            <h2 className="text-[40px] font-semibold">Payment Successful</h2>
            <p className="text-sm flex text-center md:w-[60%] w-[90%] text-muted-foreground mt-1">
              Your payment has been confirmed. You will receive your medication shortly.
            </p>

            <div className="w-full mt-6 text-sm text-left space-y-4">
              <div className="flex justify-between">
                <span className="#2D2F35">{refillMedicationResponse.medication.name}</span>
                <span className="text-[#202020CC]">
                  $ {refillMedicationResponse.medication.cost}
                </span>
              </div>

              <div className="flex justify-between">
                <span className="#2D2F35">Payment Method</span>
                <span className="text-[#202020CC]">
                  Stripe
                </span>
              </div>

              <div className="flex justify-between">
                <span className="#2D2F35">Total</span>
                <span className="text-[#202020CC]">
                  ${refillMedicationResponse.medication.cost}
                </span>
              </div>
            </div>

            <Link to="/dashboard/weight-loss/medicals" className={"mt-6 w-full text-white h-11 flex justify-center items-center rounded-lg bg-[#4272DD]"}>Return to dashboard</Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
